import { render, staticRenderFns } from "./digitizing.vue?vue&type=template&id=c13bed22&scoped=true&"
import script from "./digitizing.vue?vue&type=script&lang=js&"
export * from "./digitizing.vue?vue&type=script&lang=js&"
import style0 from "./digitizing.vue?vue&type=style&index=0&id=c13bed22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13bed22",
  null
  
)

export default component.exports